import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import TheoryExamplesRunner from "../../components/TheoryExamplesRunner";

const examples = [
  {
    label: "Przykład 1. Mnożenie potęg",
    summary: "Ta sama podstawa — dodajemy wykładniki",
    content: (
      <>
        <BlockMath math="3^4\cdot 3^2=3^{4+2}=3^6" />
        <p>
          Podstawa się nie zmienia. Przy mnożeniu potęg o tej samej podstawie
          dodajemy wykładniki.
        </p>
      </>
    ),
  },
  {
    label: "Przykład 2. Dzielenie potęg",
    summary: "Ta sama podstawa — odejmujemy wykładniki",
    content: (
      <>
        <BlockMath math="\dfrac{5^7}{5^3}=5^{7-3}=5^4" />
        <p>
          Przy dzieleniu potęg o tej samej podstawie odejmujemy wykładnik
          mianownika od wykładnika licznika.
        </p>
      </>
    ),
  },
  {
    label: "Przykład 3. Potęga potęgi",
    summary: "(aᵐ)ⁿ — mnożymy wykładniki",
    content: (
      <>
        <BlockMath math="\left(2^3\right)^4=2^{3\cdot4}=2^{12}" />
        <p>
          Gdy potęgujemy potęgę, pozostawiamy tę samą podstawę i mnożymy
          wykładniki.
        </p>
      </>
    ),
  },
  {
    label: "Przykład 4. Wykładnik ujemny",
    summary: "a⁻ⁿ — przechodzimy do odwrotności",
    content: (
      <>
        <BlockMath math="4^{-3}=\dfrac{1}{4^3}=\dfrac{1}{64}" />
        <p>
          Ujemny wykładnik oznacza odwrotność liczby z takim samym
          wykładnikiem dodatnim.
        </p>
      </>
    ),
  },
  {
    label: "Przykład 5. Sprowadzanie do wspólnej podstawy",
    summary: "25³ : 5²",
    content: (
      <>
        <p>
          Najpierw zauważamy, że <InlineMath math="25=5^2" />.
        </p>
        <BlockMath math="\dfrac{25^3}{5^2}
          =\dfrac{\left(5^2\right)^3}{5^2}
          =\dfrac{5^6}{5^2}
          =5^{6-2}=5^4" />
        <p>
          To jest kluczowy krok w zadaniach maturalnych, w których występują
          liczby z jednej rodziny, np. 2, 4, 8 albo 5, 25, 125.
        </p>
      </>
    ),
  },
  {
    label: "Przykład 6. Pierwiastek jako potęga wymierna",
    summary: "√[q](aᵖ) = aᵖ⁄q",
    content: (
      <>
        <BlockMath math="\sqrt[q]{a^p}=a^{\frac{p}{q}}" />
        <BlockMath math="\sqrt[3]{5^2\sqrt5}
          =\left(5^2\cdot5^{\frac12}\right)^{\frac13}
          =\left(5^{\frac52}\right)^{\frac13}
          =5^{\frac56}" />
        <p>
          Najpierw zapisujemy każdy pierwiastek jako potęgę, następnie
          łączymy wykładniki i na końcu uwzględniamy zewnętrzny pierwiastek.
        </p>
      </>
    ),
  },

{label:'Uzupełnienie. Suma potęg',summary:'Najpierw wyłączamy wspólny czynnik',content:(<><BlockMath math={String.raw`\frac{3^5+3^6+3^7}{3^5}=\frac{3^5(1+3+9)}{3^5}=13`} /><p>Reguła dodawania wykładników dotyczy mnożenia potęg, nie ich dodawania.</p></>)},
{label:'Uzupełnienie. Ujemny wykładnik wymierny',summary:'Odwracamy ułamek i wyciągamy pierwiastek',content:(<><BlockMath math={String.raw`\left(\frac4{25}\right)^{-\frac12}=\sqrt{\frac{25}{4}}=\frac52`} /><BlockMath math={String.raw`(-2)^4=16,\qquad -2^4=-16`} /><p>Minus w podstawie wymaga nawiasów; ujemny wykładnik oznacza odwrotność, nie zmianę znaku.</p></>)},


];

export default function PowersPreparationTheory() {
  return (
    <TheoryExamplesRunner
      title="Potęgi — najważniejsze reguły"
      intro={(
        <>
          <p>
            Dla wykładników wymiernych korzystamy tutaj z dodatniej podstawy; mianownik wykładnika jest dodatnią liczbą całkowitą. Przy dzieleniu i ujemnych wykładnikach podstawa nie może być zerem.
          Potęga <InlineMath math="a^n" /> oznacza iloczyn jednakowych
            czynników. W zadaniach maturalnych najważniejsze jest rozpoznanie
            wspólnej podstawy i poprawne wykonanie działania na wykładnikach.
          </p>
          <BlockMath math="a^m\cdot a^n=a^{m+n},\qquad
            \dfrac{a^m}{a^n}=a^{m-n},\qquad
            (a^m)^n=a^{mn}" />
          <BlockMath math="a^{-n}=\dfrac1{a^n},\qquad
            a^{\frac pq}=\sqrt[q]{a^p}" />
        </>
      )}
      examples={examples}
    />
  );
}
